var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('headmenu'),_c('div',{staticClass:"apply"},[_vm._m(0),_c('Form')],1),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("入会申请")]),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }